export default function renderInlineSvg(icon) {
  return {__html: icon};
}
